// login.component.ts
import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MsalModule } from '@azure/msal-angular';
import { AuthService } from '../../core/services/auth.service';
import { clearMSALInteractionState } from '@/app/core/utilities/utils';
import { Brand } from '@/app/consts/brand.config';
import { environment } from '@/environments/environment';
import { getCurrentRegion, isProduction } from '@/app/utils/env.util';
import { getPath, PathUnit } from '@/app/consts/path.const';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, MsalModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  isLoggingIn = false;
  ifCNRegion = getCurrentRegion() === 'cn';
  
  production = environment.production;
  ngOnInit(){
    const urlParams = new URLSearchParams(window.location.search);
    const autoLogin = urlParams.get('autologin');
    const brandParam = (urlParams.get('brand') || '').toLowerCase();
    const autoLoginBrand: Brand =
      brandParam === 'cn' || brandParam === 'international' || brandParam === 'com'
        ? (brandParam as Brand)
        : (this.ifCNRegion ? 'cn' : 'com');

    if (autoLogin === 'true') {
      this.login(autoLoginBrand);
    }
  }

  async login(brand: Brand) {
    if(this.isLoggingIn) return;
     
    this.isLoggingIn = true;

    if(!isProduction()) {
      if (getCurrentRegion() === 'com' && brand === 'cn' && !this.isLocalDevHost()) {
        window.location.href = this.buildCnAutoLoginUrl();
        return;
      }
    }

    try{
      await this.authService.setAuthType(brand);
      const scopes = this.authService.getScopes();
      await this.authService.initialize();
      clearMSALInteractionState();
      const result = this.authService
        .loginRedirect({ scopes: scopes })
        .then(() => console.log('Redirect initiated'))
        .catch((err) => console.error('Redirect failed', err));
      console.log(result);
    } catch (error) {
      console.error('Login failed', error);
    } finally {
      this.isLoggingIn = false;
    }
  }

  logout() {
    this.authService.fullLogout();
  }

  // navigate to dashboard
  navigateToDashboard() {
    this.router.navigate([getPath(PathUnit.LandingPage)]);
  }

  private buildCnAutoLoginUrl(): string {
    const url = new URL(window.location.href);
    const isLocalDevHost = this.isLocalDevHost(url.hostname);

    if (!isLocalDevHost && !url.hostname.endsWith('.cn')) {
      url.hostname = `${url.hostname}.cn`;
    }

    url.pathname = `/${getPath(PathUnit.Login)}`;
    url.search = 'autologin=true&brand=cn';

    return url.toString();
  }

  private isLocalDevHost(hostname?: string): boolean {
    const host = hostname ?? window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1';
  }
}
